import { type PropsWithChildren, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { MIN_LG, MIN_MD, MIN_XS } from '../constants/breakpoints';

type Props = PropsWithChildren<{}>;

export const useIsMobile = () => useMediaQuery({ maxWidth: MIN_MD - 1 });

// This is a workaround for the useMediaQuery hook on SSR
// The above version returns false during SSR and then updates on the client side (before rendering) creating a mismatch
// This version introduces a state variable that changes after the component mounts, preventing any error.
export const useIsMobileSSR = () => {
  const [isMounted, setIsMounted] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: MIN_MD - 1 });

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? isMobile : false;
};

export const Mobile = ({ children }: Props) => (useIsMobile() ? children : null);

export const useIsTablet = () => useMediaQuery({ minWidth: MIN_MD, maxWidth: MIN_LG - 1 });

export const Tablet = ({ children }: Props) => (useIsTablet() ? children : null);

export const useIsDesktopOrTablet = () => useMediaQuery({ minWidth: MIN_MD });

export const DesktopAndTablet = ({ children }: Props) => (useIsDesktopOrTablet() ? children : null);

export const useIsDesktop = () => useMediaQuery({ minWidth: MIN_LG });

export const Desktop = ({ children }: Props) => (useIsDesktop() ? children : null);

// e.g. iPhone 5 and others
export const useIsExtraSmallDevice = () => useMediaQuery({ maxWidth: MIN_XS });
